import { createSelector } from 'reselect';
import _ from 'lodash';

export const offerSelector = state => state.offers.offerData;
export const offersFlowTypeSelector = state => state.offers.flowType;
export const localizedSelector = state => state.offers.localized;
export const overlaySelector = state => state.overlay.overlays;
export const overlayDataSelector = state => state.overlay.overlayData;

export const errorListDataSelector = createSelector(
  overlayDataSelector,
  overlayData => _.get(overlayData, 'errorOverlay.errorList', [])
);

export const extractPrice = (price) => {
  const amount = _.get(_.head(price.prices), 'amount');
  const amountNumber = parseFloat(`${amount.dollars}.${amount.cents}`);

  return amountNumber;
};

export const aggregateOffers = (processedOffers) => {
  // group all related offers
  let processedIds = [];

  return _.compact(processedOffers.map((offer) => {
    if (_.includes(processedIds, offer.id)) {
      return null;
    }

    let relatedOffers = [];

    relatedOffers = _.union([offer], _.filter(processedOffers, _.flow(
      _.property('relatedOffers'),
      _.partialRight(_.some, { id: offer.id })
    )));

    _.forEach(relatedOffers, (offer) => processedIds.push(offer.id)); // eslint-disable-line lodash/prefer-map

    return relatedOffers;
  }));
};

export const LobValuesfromAggregate = (offers) => {
  return _.isEmpty(offers)
  ? []
  : _.head(_.head(offers)).linesOfBusiness;
};

export const formatOffersForDataLayer = (offers) => _.map(offers, offer => {
  const tierKeys = Object.keys(offer.metadata).filter(key => key.slice(-5) === "_TIER");
  const lobSummary = lobs => {
    const uncapsLobs = _.map(lobs, lob => lob.toLowerCase());

    if (uncapsLobs.length === 4) {
      return `quad play|${uncapsLobs.join('|')}`;
    } else if (uncapsLobs.length === 3) {
      return `triple play|${uncapsLobs.join('|')}`;
    } else if (uncapsLobs.length === 2) {
      return `double play|${uncapsLobs.join('|')}`;
    } else {
      return uncapsLobs[0];
    }
  };

  return {
    productID: offer.id,
    LOB: lobSummary(offer.linesOfBusiness),
    system: "SCMS",
    tier: tierKeys.map(tierKey => offer.metadata[tierKey]).join('/') || ""
  };
});

export const lobString = (lobs) => {

  let summaryTitle = '';

  if (!_.isEmpty(lobs)) {
    const initialLobs = _.initial(lobs).join(', ');

    summaryTitle = _.isEmpty(initialLobs) ? summaryTitle: ` ${initialLobs}`;
    summaryTitle = _.size(lobs) <= 1 ? summaryTitle : `${summaryTitle} and`;
    summaryTitle = _.trim(`${summaryTitle} ${_.last(lobs)}`);
  }

  return summaryTitle;
};

export const roundValue = (number, nearest) => Math.round(number/nearest)*nearest;
export const roundFloor = (number, nearest) => Math.floor(number/nearest)*nearest;



/** WEBPACK FOOTER **
 ** ./client/redux/modules/data/offers/offersHelpers.js
 **/